
document.addEventListener("DOMContentLoaded", function () {
  // if (document.body.id !== "snowflakes-test-page") return;

  const snowContainer = document.querySelector('.snow-container');
  if (!snowContainer) return;

  const snowflakeCount = 30; // number of snowflakes
  for (let i = 0; i < snowflakeCount; i++) {
    const snowflake = document.createElement('div');
    snowflake.classList.add('snowflake');
    snowflake.innerHTML = '❄'; // You can use * or emoji

    snowflake.style.left = Math.random() * 100 + "vw";
    snowflake.style.animationDuration = 3 + Math.random() * 12 + "s";
    snowflake.style.fontSize = 10 + Math.random() * 5 + "px";
    snowflake.style.opacity = Math.random();

    snowContainer.appendChild(snowflake);
  }
});
